import logoAd from '~/assets/Images/logoAdAzul.png';
import { Container, Img, LoadingCircle } from './styles';

const Loading: React.FC = () => {
  return (
    <Container>
      <LoadingCircle />
      <Img src={logoAd} alt="logo da Assembleia de Deus" />
    </Container>
  );
};

export default Loading;
